import { FaFingerprint } from "react-icons/fa";
import { MdBrandingWatermark } from "react-icons/md";
import { GiCash } from "react-icons/gi";
import { IoDocumentTextSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import { RiTeamFill } from "react-icons/ri";

const Config = () => {
  return (
    <div className=" mt-5 grid-cols-4 grid ">
      <div>
        <Link to="/teams">
          <div className="p-3  rounded-md shadow-lg w-[200px] h-[150px]">
            <div className=" flex justify-center mt-3">
              <RiTeamFill className=" text-red-600" fontSize={60} />
            </div>
            <span className="font-bold items-center text-center flex justify-center p-3">
              Team
            </span>
          </div>
        </Link>
      </div>

      {/* <div>
        <Link to="/breadingTable">
          <div className="p-3  rounded-md shadow-lg w-[200px] h-[150px]">
            <div className=" flex justify-center mt-3">
              <MdBrandingWatermark className="text-red-600" fontSize={60} />
            </div>
            <span className="font-bold items-center text-center flex justify-center p-3">
              Breanding
            </span>
          </div>
        </Link>
      </div>

      <div>
        <Link to="/paymentModeTable">
          <div className="p-3  rounded-md shadow-lg w-[200px] h-[150px]">
            <div className=" flex justify-center mt-3">
              <GiCash className="text-red-600" fontSize={60} />
            </div>
            <span className="font-bold items-center text-center flex justify-center p-3">
              Payment Mode
            </span>
          </div>
        </Link>
      </div>

      <div>
        <Link to="/documentTable">
          <div className="p-3  rounded-md shadow-lg w-[200px] h-[150px]">
            <div className=" flex justify-center mt-3">
              <IoDocumentTextSharp className="text-red-600" fontSize={60} />
            </div>
            <span className="font-bold items-center text-center flex justify-center p-3">
              Document Type
            </span>
          </div>
        </Link>
      </div> */}
    </div>
  );
};
export default Config;


